// src/pages/Home/Components/Discount.jsx
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HiOutlineGift, HiOutlineTag, HiOutlineShoppingBag } from 'react-icons/hi';
import discountImage from "../../../img/Discount.webp";

const FALLBACK_IMAGE =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='380' viewBox='0 0 400 380'%3E%3Crect fill='%23F4F1EA' width='400' height='380'/%3E%3Ctext fill='%238A9A7B' font-family='sans-serif' font-size='16' x='50%25' y='50%25' text-anchor='middle' dy='.3em'%3Eتخفیف ویژه%3C/text%3E%3C/svg%3E";

export default function Discount() {
  const navigate = useNavigate();
  const [imageError, setImageError] = useState(false);

  const handleViewAll = () => {
    navigate('/discount');
  };

  return (
    <section className="mx-auto mt-8 flex max-w-[1006px] flex-col overflow-hidden rounded-2xl shadow-lg sm:flex-row-reverse">

      {/* ---- بخش عکس ---- */}
      <div className="w-full sm:w-1/2 flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#F4F1EA] to-[#E8E4DC]">
        <img
          src={imageError ? FALLBACK_IMAGE : discountImage}
          alt="تخفیف ویژه"
          className="w-full h-full object-cover object-center transition-transform duration-700 hover:scale-110"
          style={{ maxHeight: '380px' }}
          onError={() => setImageError(true)}
          loading="lazy"
        />
      </div>

      {/* ---- بخش محتوا ---- */}
      <div className="flex w-full flex-col items-center justify-center gap-4 px-8 py-10 text-center sm:w-1/2 bg-white relative">

        {/* نشانگر تخفیف */}
        <div className="flex items-center gap-2 rounded-full bg-[#8A9A7B]/10 px-4 py-1.5">
          <HiOutlineTag className="text-[#8A9A7B] text-sm" />
          <span className="text-xs font-semibold text-[#8A9A7B] tracking-wider">
            تخفیف ویژه
          </span>
        </div>

        <h2 className="text-2xl font-bold leading-snug text-[#292524]">
          پیشنهاد <span className="text-[#8A9A7B]">عالی برای خرید</span>
        </h2>

        <p className="text-sm text-[#79716B] max-w-[280px] leading-relaxed">
          تا ۵۰٪ تخفیف ویژه برای محصولات با کیفیت — فرصت استثنایی رو از دست نده!
        </p>

        {/* ویژگی‌ها */}
        <div className="flex flex-wrap items-center justify-center gap-4 mt-1">
          <div className="flex items-center gap-1.5 text-xs text-[#79716B]">
            <HiOutlineGift className="text-[#8A9A7B] text-base" />
            <span>پیشنهاد لحظه‌ای</span>
          </div>
          <div className="w-px h-4 bg-[#E5E0DB]"></div>
          <div className="flex items-center gap-1.5 text-xs text-[#79716B]">
            <HiOutlineShoppingBag className="text-[#8A9A7B] text-base" />
            <span>تنوع بالا</span>
          </div>
        </div>

        {/* دکمه */}
        <button
          onClick={handleViewAll}
          aria-label="مشاهده محصولات تخفیف‌دار"
          className="mt-2 rounded-xl px-10 py-3 text-sm font-medium text-white shadow-md transition-all duration-300 bg-[#8A9A7B] hover:bg-[#6B7D5E] hover:shadow-xl hover:scale-[1.02] active:scale-95 relative overflow-hidden group"
        >
          <span className="relative z-10 flex items-center gap-2">
            <HiOutlineShoppingBag className="text-lg" />
            رفتن به کمد تخفیفات چوبی
          </span>
        </button>
      </div>
    </section>
  );
}